import { getActiveWargameConfig } from '@gamecodex/wargame-config'
import { Button, type ButtonProps } from './ui/Button'

const DEFAULT_LABEL: Record<'prelaunch' | 'live', string> = {
  prelaunch: 'Notify Me on Launch',
  live: 'Back Us on Kickstarter',
}

/** Renders nothing until `WargameConfig.kickstarter` is set with a real URL. */
export function KickstarterCTA(props: Pick<ButtonProps, 'variant' | 'size' | 'className'>) {
  const ks = getActiveWargameConfig().kickstarter
  if (!ks?.url) return null
  return (
    <a href={ks.url} target="_blank" rel="noopener noreferrer">
      <Button variant={props.variant ?? 'ghost'} size={props.size} className={props.className}>
        {ks.label ?? DEFAULT_LABEL[ks.status]}
      </Button>
    </a>
  )
}
